import { useEffect, useState } from 'react';
import { db } from '../firebase';
import {
    collection,
    onSnapshot,
    query,
    orderBy,
    deleteDoc,
    doc
} from 'firebase/firestore';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

const EventsList = () => {
    const [events, setEvents] = useState([]);
    const [user, setUser] = useState(null);

    useEffect(() => {
        const auth = getAuth();
        const unsubscribeAuth = onAuthStateChanged(auth, (firebaseUser) => {
            setUser(firebaseUser);
        });

        return unsubscribeAuth;
    }, []);

    useEffect(() => {
        const q = query(collection(db, 'events'), orderBy('timestamp', 'desc'));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const eventsData = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
                formattedDate: new Date(doc.data().date).toLocaleDateString('en-US', {
                    timeZone: 'UTC',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                })
            }));
            setEvents(eventsData);
        });

        return unsubscribe;
    }, []);

    const handleDelete = async (eventId) => {
        const confirmDelete = window.confirm('Are you sure you want to delete this event?');
        if (!confirmDelete) return;

        try {
            await deleteDoc(doc(db, 'events', eventId));
            alert('Event deleted.');
        } catch (error) {
            alert(`Error deleting event: ${error.message}`);
        }
    };

    return (
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
            {events.length === 0 ? (
                <p className="text-center text-gray-400 text-base col-span-full py-8">No upcoming events — check back soon.</p>
            ) : (
                events.map((event) => (
                    <div
                        key={event.id}
                        className="relative bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-0.5 flex flex-col h-full"
                    >
                        {user && (
                            <button
                                onClick={() => handleDelete(event.id)}
                                className="absolute top-3 right-4 text-gray-300 hover:text-red-500 transition-colors text-2xl font-bold leading-none"
                                title="Delete Event"
                            >
                                ×
                            </button>
                        )}
                        <div className="p-6 flex-grow">
                            <p className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-2">{event.formattedDate}</p>
                            <h3 className="text-lg font-bold text-black leading-snug">{event.title}</h3>
                        </div>
                        <div className="px-6 pb-6">
                            {event.link ? (
                                <a
                                    href={event.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center gap-1.5 w-full justify-center bg-black text-white px-4 py-2.5 rounded-xl hover:bg-gray-800 transition-colors text-sm font-medium"
                                >
                                    View Event
                                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                    </svg>
                                </a>
                            ) : (
                                <p className="text-gray-400 text-sm text-center">No link available</p>
                            )}
                        </div>
                    </div>
                ))
            )}
        </div>
    );
};

export default EventsList;
